import React from 'react';

var Measurement = function Measurement(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15.18 5.28l-9.9 9.9 3.535 3.535 9.9-9.9-3.536-3.535zm.706-2.122l4.95 4.95a1 1 0 0 1 0 1.414L9.522 20.836a1 1 0 0 1-1.414 0l-4.95-4.95a1 1 0 0 1 0-1.414L14.472 3.158a1 1 0 0 1 1.414 0zM6.158 13.573a1 1 0 0 1 1.415-1.415l2 2a1 1 0 1 1-1.415 1.415l-2-2zm3-3a1 1 0 0 1 1.415-1.415l1 1a1 1 0 0 1-1.415 1.415l-1-1zm3-3a1 1 0 1 1 1.415-1.415l2 2a1 1 0 1 1-1.415 1.415l-2-2z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Measurement.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Measurement as icon };
export default iconHandler(Measurement);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/Measurement.js
// module id = 609
// module chunks = 0